import { intersect, string, struct } from 'io-ts/Decoder';

import { Params as BaseParams } from '../../../comment/create/Params';

export const Params = intersect(BaseParams)(
	struct({
		variationId: string,
	})
);
